import { InputProps } from "@heroui/input/dist/input";
import { Button, Input } from "@heroui/react";
import React, { useState } from "react";
import { Control, Controller, ControllerRenderProps } from "react-hook-form";
import { IconCheck, IconCircleX } from "@tabler/icons-react";

export type FormInputProps = {
  name: string;
  control: Control<any, string>;
} & InputProps;

type InputValue = { id?: string; value: string };

export const FormInputList: React.FC<FormInputProps> = ({ name, ...props }) => {
  const [inputValue, setInputValue] = useState("");

  const handleButtonClick = (field: ControllerRenderProps<any, string>) => {
    if (inputValue.trim() !== "") {
      const newValue = { value: inputValue };
      console.log({ currentValue: field.value, newValue });
      const newInputValues =
        field.value && Array.isArray(field.value)
          ? [...field.value, newValue]
          : [newValue];
      field.onChange(newInputValues);
      setInputValue("");
    }
  };
  const removeValue = (
    field: ControllerRenderProps<any, string>,
    indexToRemove: number
  ) => {
    const newValues = field.value.filter(
      (_: any, index: number) => index !== indexToRemove
    );
    field.onChange(newValues);
  };

  return (
    <Controller
      name={name}
      control={props.control}
      render={({ field, fieldState, formState }) => {
        return (
          <>
            <div className={"flex flex-col w-full"}>
              <div className={"flex flex-row w-full"}>
                <Input
                  {...props}
                  isInvalid={!!formState.errors?.[name]?.message}
                  errorMessage={formState.errors?.[name]?.message?.toString()}
                  value={inputValue}
                  onChange={(e) => {
                    setInputValue(e.target.value);
                    // if (e.target.value !== "") {
                    //   props.control.setError(name, {
                    //     type: "custom",
                    //     message: "Clear input or confirm the input value",
                    //   });
                    // }
                  }}
                  endContent={
                    <Button
                      size={"sm"}
                      isIconOnly={true}
                      type={"button"}
                      onPress={() => handleButtonClick(field)}
                    >
                      <IconCheck />
                    </Button>
                  }
                />
              </div>
              {field.value?.length > 0 && (
                <div className={"flex flex-row flex-wrap mt-1"}>
                  {field.value.map((inputValue: InputValue, index: number) => (
                    <Button
                      type={"button"}
                      onPress={() => removeValue(field, index)}
                      className={"rounded-md m-1"}
                      key={index}
                      endContent={<IconCircleX />}
                    >
                      {inputValue.value}
                    </Button>
                  ))}
                </div>
              )}
            </div>
          </>
        );
      }}
    ></Controller>
  );
};
